import styled from 'styled-components'
import { getCalendarWrapperStyles } from '../style'

const StyledCalendarWrapper = styled.div`
    ${getCalendarWrapperStyles}
`

export default StyledCalendarWrapper
